import { useNavigate } from "react-router-dom";
import { AlertCircle } from "lucide-react";

export default function MemberVerify() {
  const nav = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream container-px py-16">
      <div className="card-premium max-w-md w-full text-center">
        <AlertCircle className="w-10 h-10 text-amber-600 mx-auto" />
        <h1 className="font-heading text-2xl text-ink mt-4">
          Magic link sign-in is disabled
        </h1>
        <p className="text-ink-soft text-sm mt-2">
          Please use email and password to sign in, or create a new account to
          start your membership form.
        </p>
        <button
          onClick={() => nav("/member/login")}
          className="btn-primary mt-5"
          data-testid="verify-back-login-btn"
        >
          Go to sign in
        </button>
      </div>
    </div>
  );
}
